var map = {
	"./add-action.svg": [
		927,
		927
	],
	"./attach-money-navbar.svg": [
		8470,
		470
	],
	"./attach-money.svg": [
		5975,
		975
	],
	"./calendar.svg": [
		5033,
		33
	],
	"./chevron-right-bottom.svg": [
		8887,
		887
	],
	"./chevron-right-top.svg": [
		8603,
		603
	],
	"./clear-action.svg": [
		5265,
		265
	],
	"./clock.svg": [
		2075,
		75
	],
	"./csv-action.svg": [
		5360,
		360
	],
	"./dashboard-last-month.svg": [
		1511,
		511
	],
	"./dashboard-month.svg": [
		2568,
		568
	],
	"./dashboard-navbar.svg": [
		9904,
		523
	],
	"./dashboard-today.svg": [
		5437,
		437
	],
	"./dashboard-total.svg": [
		2544,
		544
	],
	"./dashboard-year.svg": [
		785,
		785
	],
	"./dashboard.svg": [
		9842,
		461
	],
	"./edit-action.svg": [
		2894,
		894
	],
	"./excel-action.svg": [
		2491,
		491
	],
	"./eye-action.svg": [
		5478,
		97
	],
	"./eye-closed.svg": [
		4531,
		531
	],
	"./eye-open.svg": [
		2815,
		815
	],
	"./image-unknown.svg": [
		8263,
		263
	],
	"./import-navbar.svg": [
		4175,
		175
	],
	"./import.svg": [
		5416,
		416
	],
	"./key.svg": [
		7000,
		0
	],
	"./location-navbar.svg": [
		5889,
		889
	],
	"./location.svg": [
		4310,
		310
	],
	"./logout-navbar.svg": [
		5904,
		904
	],
	"./logout.svg": [
		4277,
		277
	],
	"./news-navbar.svg": [
		7329,
		329
	],
	"./news.svg": [
		8566,
		185
	],
	"./notification-navbar.svg": [
		8369,
		369
	],
	"./notification.svg": [
		566,
		566
	],
	"./percent-navbar.svg": [
		3237,
		237
	],
	"./percent.svg": [
		7594,
		594
	],
	"./removeorcancel-action.svg": [
		4213,
		213
	],
	"./save-action.svg": [
		7123,
		123
	],
	"./search-action.svg": [
		7206,
		206
	],
	"./search.svg": [
		4343,
		343
	],
	"./share.svg": [
		7300,
		300
	],
	"./trash-action.svg": [
		1554,
		554
	],
	"./union.svg": [
		6875,
		256
	],
	"./upload.svg": [
		600,
		600
	],
	"./user.svg": [
		698,
		698
	],
	"./users-navbar.svg": [
		6320,
		320
	],
	"./users.svg": [
		3557,
		557
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4913;
module.exports = webpackAsyncContext;